export default {
  'menu.LicenseNewPage': '新建证件',
  'menu.LicenseEditPage': '更新证件',

}